<template>
    <el-row>
        <el-col :span="24">
            <el-row>
                <h1>Approve Customer</h1>
            </el-row>
        </el-col>
      <el-col :span="24">
        <el-card shadow="never">
          <el-row>
            <el-tabs type="card" v-model="activeName" >
                <el-tab-pane v-for="item in listMenu" :key="item.id" class="tabLeadPool" :label="item.label" :name="item.name"></el-tab-pane>
                 <keep-alive>
                    <component v-bind:is="currentTabComponent"></component>
                  </keep-alive>
            </el-tabs>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
</template>

<script>
import Approve from '@/components/leadpool/ApproveCustomerList'
export default {
    name: 'ConfirmCustomer',
    components: {
        Approve
    },
    data () {
        return {
            activeName: 'Approve',
            listMenu: [
                { id: 0, name: 'Approve', label: 'Approve Customer' }
            ]
        }
    },
    computed: {
        currentTabComponent: function () {
            return this.activeName
        }
    },
    created () {},
    methods: {}
}
</script>
<style lang="scss" scoped>
.tabLeadPool{
    // .el-tabs__nav-scroll {
    //     background-color: black;
    // }
    .el-tabs__item{
        color: white !important;
         background-color: black;

    }
     .is-active{
        color: teal !important;
        background-color: white;
    }

}
</style>
